import React from 'react'
import {
    UploadProps,
    message,
    UploadFile,
    Button,
    Upload,
    FormListFieldData,
    FormInstance,
} from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadOutlined } from '@ant-design/icons'
import type { UploadRequestOption } from 'rc-upload/lib/interface'
import { uploadFileToGCS } from '../../../../../../../service/gcs-upload.service'

interface InputUploadFileProps {
    form: FormInstance
    field: FormListFieldData
    subField: FormListFieldData
    initialValues?: string
}

const InputUploadFile: React.FC<InputUploadFileProps> = ({
    form,
    field,
    subField,
    initialValues,
}) => {
    const [fileList, setFileList] = React.useState<UploadFile[]>([])

    React.useEffect(() => {
        if (initialValues) {
            const fileName = initialValues.split('/').pop()?.split('_').shift()
            setFileList([
                {
                    uid: subField.key.toString(),
                    name: fileName || '',
                    status: 'done',
                    url: initialValues,
                },
            ])
        } else {
            setFileList([])
        }
    }, [subField, initialValues])

    const customRequest = async (options: UploadRequestOption) => {
        const { file, onProgress, onSuccess, onError } = options
        try {
            const result = await uploadFileToGCS(
                file as File,
                'pdf',
                (percent) => onProgress?.({ percent } as unknown as ProgressEvent)
            )
            message.success(`${(file as File).name} อัปโหลดไฟล์เสร็จสิ้น`)
            form.setFieldValue(
                ['productItem', field.name, 'choiceItem', subField.key, 'file'],
                result.url
            )
            onSuccess?.(result)
        } catch (err) {
            message.error(
                `${(file as File).name} อัปโหลดไฟล์ล้มเหลว: ${(err as Error).message}`
            )
            onError?.(err as Error)
        }
    }

    const uploadProps: UploadProps = {
        name: 'file',
        accept: 'application/pdf',
        maxCount: 1,
        fileList,
        customRequest,
        onChange: (info: UploadChangeParam) => {
            setFileList(info.fileList)
        },
        onPreview: async (file: UploadFile) => {
            window.open(file.url || file.response?.url, '_blank')
        },
        onRemove: () => {
            form.setFieldValue(
                ['productItem', field.name, 'choiceItem', subField.key, 'file'],
                undefined
            )
        },
    }

    const isError =
        form.getFieldError([
            'productItem',
            field.name,
            'choiceItem',
            subField.key,
            'file',
        ]).length !== 0

    return (
        <Upload {...uploadProps}>
            <Button danger={isError} icon={<UploadOutlined />}>
                อัปโหลดไฟล์
            </Button>
        </Upload>
    )
}

export default InputUploadFile
